module.exports = __webpack_public_path__ + "media/images/base/sprite-0969fcd60176beb87f19485b9fc4789d.svg";